import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { colors } from '../constants/colors.js';
import { fontWeights } from '../constants/font-weights.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var buttonAttributesNative = {
  color: 'primary',
  foregroundColor: 'background',
  disabled: {
    textColor: 'text.disabled',
    textColorTransparent: 'rgba(255, 255, 255, 0.4)',
    backgroundColor: 'background.secondary',
    backgroundColorTransparent: 'rgba(255, 255, 255, 0.2)'
  },
  campaign: {
    textColor: colors.ivyGreen900,
    backgroundColor: colors.poweringGreen500,
    disabledBackground: '#116A3C'
  },
  plain: {
    background: 'transparent',
    foreground: 'transparent'
  },
  font: {
    size: 18,
    weight: fontWeights.regular
  },
  padding: {
    condensed: 24,
    xs: 24,
    s: 32,
    m: 40,
    l: 48
  },
  /**
   * Gap between the text and the icon
   */
  iconMargin: 8,
  height: {
    /**
     * Condensed height recorded with other sizes to keep types simple
     */
    condensed: 40,
    xs: 40,
    s: 48,
    m: 56,
    l: 64
  },
  border: {
    width: 2,
    style: 'solid'
  }
};
var buttonThemeNative = _objectSpread(_objectSpread({}, buttonAttributesNative), {}, {
  variants: {
    condensed: {
      font: {
        size: 16
      },
      paddingMode: 'balanced',
      iconMargin: 8
    }
  }
});
var buttonDarkThemNative = _objectSpread(_objectSpread({}, buttonThemeNative), {}, {
  disabled: _objectSpread(_objectSpread({}, buttonThemeNative.disabled), {}, {
    /** FIXME - The label color is set to a theme-specific value unlike the web version.
        The native version should propably be updated to use a calculated value */
    textColor: 'label.disabled'
  })
});
var buttonAttributesWeb = {
  color: 'primary',
  disabledColor: 'button.disabled',
  borders: {
    radius: 'borders.radius',
    width: 2
  },
  hoverLuminance: -8,
  activeLuminance: -16,
  font: {
    size: {
      condensed: 16,
      xs: 16,
      s: 18,
      m: 18,
      l: 18
    },
    weight: {
      condensed: 400,
      xs: 400,
      s: 400,
      m: 400,
      l: 400
    }
  },
  icon: {
    size: 24
  },
  height: {
    condensed: 40,
    xs: 40,
    s: 48,
    m: 56,
    l: 64
  },
  paddings: {
    /**
     * Padding to the left and right of the content
     */
    horizontal: {
      condensed: 24,
      xs: 24,
      s: 32,
      m: 40,
      l: 48
    },
    /**
     * Padding between the icon and the text
     */
    afterIcon: 8,
    /**
     * Padding used for plain buttons
     */
    plain: 26,
    /**
     * Padding applied to button element
     */
    top: 0,
    /**
     * Padding applied to button element
     */
    bottom: 0
  },
  margins: {
    text: {
      /**
       * Use this to correct text vertical position
       */
      top: 0
    }
  },
  autoResize: {
    alignContent: 'center',
    paddingBlock: 2
  },
  campaign: {
    textColor: colors.ivyGreen900,
    backgroundColor: colors.poweringGreen500,
    backgroundHover: '#41e78e',
    backgroundActive: '#7ff6b6',
    disabledBackground: '#116a3c'
  }
};
var buttonThemeWeb = buttonAttributesWeb;
var buttonDarkThemeWeb = _objectSpread(_objectSpread({}, buttonThemeWeb), {}, {
  hoverLuminance: -5,
  activeLuminance: -10
});

export { buttonDarkThemNative, buttonDarkThemeWeb, buttonThemeNative, buttonThemeWeb };
